export const search_en = {
    text: 'Our search will help you find faster',
    input_text: 'Enter the name of the organization',
    searchbtn: 'Find',
    select_text: 'All product groups'
}